

jQuery( document ).ready(function($) {
  
  var smartwizard       = document.getElementById('appWrapper');
  var nextBtn           = document.getElementById('nextBtn');
  var designBtn         = document.getElementById('designBtn');
  var poTySelRadio      = document.querySelector('input[name=posttypeSelect]');
  var poTySelRadioCheck = document.querySelector('input[name=posttypeSelect]:checked');

  var postTypeUrl = '';
  var postType    = '';
  var stepInfo    = '';
  var currentStep = '';
  
  var laGenBox    = '';
  var inImgLa     = '';
  var outImgLa    = '';
  var dcbtn       = '';

  var inTXTSub    = '';
  var outTXTSub   = '';

  var inTXTHead   = '';
  var outTXTHead  = '';
  
  var inTXTText   = '';
  var outTXTText  = '';

  var inTXThash   = '';
  var outTXThash  = '';

  var inTXTLoc    = '';
  var outTXTLoc   = '';

  var inFiTxt     = '';
  var outFiTxt    = '';
  var inScTxt     = '';
  var outScTxt    = '';



  // Steps Wizzard for App selection Function 
  ///////////////////////////////////////////////////////////


  // set function for Ajax Content
  /////////////////////////////////////////
  function provideContent(idx, stepDirection, stepPosition, selStep, callback) {
    // Only get ajax content on the forward movement
    if ( idx == '2' || idx == '3') {

      contentUrl = selStep.data('content');
      let ajaxURL = contentUrl;
      // Ajax call to fetch your content
      $.ajax({
          method  : "GET",
          url     : ajaxURL,
          cache   : false,
          beforeSend: function( xhr ) {
              // Show the loader
              $(smartwizard).smartWizard("loader", "show");
          }
      }).done(function( res ) {
        // let data = res;      
        var html = res;

        // Resolve the Promise with the tab content
        callback(html);

        $('#appWrapper').imagesLoaded().then(function(){
          // Hide the loader
          $(smartwizard).smartWizard("loader", "hide");
          $(window).trigger('resize');
        });

      }).fail(function(err) {
          // Reject the Promise with error message to show as tab content
          callback( "An error loading the resource" );

          // Hide the loader
          $(smartwizard).smartWizard("loader", "hide");
      });
  
    }
    callback();
  }

  // set function for Jquery Smart Wizzard
  /////////////////////////////////////////
  $(smartwizard).smartWizard({
    selected: 0,
    theme: 'dots',
    enableUrlHash: true, // Enable selection of the step based on url hash
    transition: {
      animation:'none', // none|fade|slideHorizontal|slideVertical|slideSwing|css
    },
    toolbar: {  
      position: 'none', // none|top|bottom|both
      /*
      showNextButton: true, // show/hide a Next button
      showPreviousButton: true, // show/hide a Previous button
      extraHtml: '' // Extra html to show on toolbar
      */
    },
    anchor: {
      enableNavigation: true, // Enable/Disable anchor navigation 
      enableNavigationAlways: false, // Activates all anchors clickable always
      enableDoneState: true, // Add done state on visited steps
      markPreviousStepsAsDone: true, // When a step selected by url hash, all previous steps are marked done
      unDoneOnBackNavigation: true, // While navigate back, done state will be cleared
      enableDoneStateNavigation: true // Enable/Disable the done state navigation
    },
    keyboard: {
      keyNavigation: false, // Enable/Disable keyboard navigation(left and right keys are used if enabled)
    },
    disabledSteps: [], // Array Steps disabled
    errorSteps: [], // Highlight step with errors
    hiddenSteps: [], // Hidden steps
    getContent: provideContent
  });

  // get current Step
  /////////////////////////////////////////
  $(smartwizard).on("showStep", function(e, anchorObject, stepIndex, stepDirection, stepPosition) {      

    stepInfo = $(smartwizard).smartWizard("getStepInfo");
    currentStep = stepInfo.currentStep;

    if (stepPosition  === 'first') {
      $(nextBtn).show().html('loslegen');
    } else if (stepPosition  === 'last') {
       $(nextBtn).hide();
    } else {
      $(nextBtn).show().html('weiter');
    }

  
    if (stepIndex == 1) {
      // set function for Ajax URL By Select Radio
      ///////////////////////////////////////////////////////////

      // set Postype Select
      $('input[name=posttypeSelect]').change(function(){
        postType = $('input[name=posttypeSelect]:checked').val();
        switch (postType) {
          case 'textpost':
            postTypeUrl =  'templates/txt-layout-select.html';
          break;
          case 'bildpost':
            postTypeUrl =  'templates/img-layout-select.html';
          break;
          case 'eventpost':
            postTypeUrl = 'templates/event-layout-select.html';
          break;
        }
        $('#select-design').attr('data-content', postTypeUrl);
        $('.vbmLayBoxIcon').removeClass('checked');
        $(this).next('.vbmLayBoxIcon').addClass('checked');
      });
         
    } else if (stepIndex == 2 ) {
      // set IMG Layout Select
      $('input[name=layoutSelect]').change(function(){
        postType = $('input[name=layoutSelect]:checked').val();
        switch (postType) {
          
          // TXT Layouts
          case 'txtLayout-1':
            postTypeUrl =  'templates/txt-layouts/txtPostLayout-1.html';
          break;
          case 'txtLayout-2':
            postTypeUrl =  'templates/txt-layouts/txtPostLayout-2.html';
          break;
          case 'txtLayout-3':
            postTypeUrl =  'templates/txt-layouts/txtPostLayout-3.html';
          break;
          
          // IMG Layouts
          case 'imgLayout-1':
            postTypeUrl =  'templates/img-layouts/imgPostLayout-1.html';
          break;
          case 'imgLayout-2':
            postTypeUrl =  'templates/img-layouts/imgPostLayout-2.html';
          break;
          case 'imgLayout-3':
            postTypeUrl =  'templates/img-layouts/imgPostLayout-3.html';
          break;
          case 'imgLayout-4':
            postTypeUrl =  'templates/img-layouts/imgPostLayout-4.html';
          break;

          // EVENT Layouts
          case 'eventLayout-1':
            postTypeUrl =  'templates/event-layouts/eventPostLayout-1.html';
          break;
          case 'eventLayout-2':
            postTypeUrl =  'templates/event-layouts/eventPostLayout-2.html';
          break;
        }
        $('#selected-design').attr('data-content', postTypeUrl);
        $('.vbmLayBoxIcon').removeClass('checked');
        $(this).next('.vbmLayBoxIcon').addClass('checked');
      });   
    } else if (stepIndex == 3) {

      if ( $('#txtPostLayout-1').length ) {
        // canvas Box
        laGenBox = document.getElementById('txtLAOneGenBox');
        
        // Border and txt sizes
        setBorderMaskWidth(laGenBox, '.borderMask', '15');
        setFontSize(laGenBox, '.head', '90');
        setFontSize(laGenBox, '.subhead', '50');
        setFontSize(laGenBox, '.text', '40');

        // TXT Change Vars TXT Layout one
        inTXTSub = document.getElementById('vbmInputSub');
        outTXTSub = document.getElementsByClassName("vbmOutputSub");
        inTXTHead = document.getElementById('vbmInputHead');
        outTXTHead = document.getElementsByClassName("vbmOutputHead");
        inTXTText = document.getElementById('vbmInputText');
        outTXTText = document.getElementsByClassName("vbmOutputText");
        
        // TXT Layou 1
        vbmChangeText(inTXTSub, outTXTSub);
        vbmChangeText(inTXTHead, outTXTHead);
        vbmChangeText(inTXTText, outTXTText);

        // create and Downlaod canvas
        dcbtn = document.getElementById('genImgTxtLAOne');
        $( dcbtn).on( "click", function(e) {
          e.preventDefault;
          vbmCreateCanvasIMG(laGenBox);
        });
      } else if ( $('#txtPostLayout-2').length ) {
        // canvas Box
        laGenBox = document.getElementById('txtLATwoGenBox');
        
        // Border and txt sizes
        setFontSize(laGenBox, '.head', '90');
        setFontSize(laGenBox, '.subhead', '50');
        setFontSize(laGenBox, '.text', '40');

        // TXT Change Vars TXT Layout one
        inTXTSub = document.getElementById('vbmInputSub');
        outTXTSub = document.getElementsByClassName("vbmOutputSub");
        inTXTHead = document.getElementById('vbmInputHead');
        outTXTHead = document.getElementsByClassName("vbmOutputHead");
        inTXTText = document.getElementById('vbmInputText');
        outTXTText = document.getElementsByClassName("vbmOutputText");
        
        // TXT Layou 1
        vbmChangeText(inTXTSub, outTXTSub);
        vbmChangeText(inTXTHead, outTXTHead);
        vbmChangeText(inTXTText, outTXTText);

        // create and Downlaod canvas
        dcbtn = document.getElementById('genImgTxtLAOne');
        $( dcbtn).on( "click", function(e) {
          e.preventDefault;
          vbmCreateCanvasIMG(laGenBox);
        });
      } else if ( $('#txtPostLayout-3').length ) {
        // canvas Box
        laGenBox = document.getElementById('txtLAThreeGenBox');
        
        // Border and txt sizes
        setFontSize(laGenBox, '.head', '90');
        setFontSize(laGenBox, '.subhead', '50');
        setFontSize(laGenBox, '.text', '40');

        // TXT Change Vars TXT Layout one
        inTXTSub = document.getElementById('vbmInputSub');
        outTXTSub = document.getElementsByClassName("vbmOutputSub");
        inTXTHead = document.getElementById('vbmInputHead');
        outTXTHead = document.getElementsByClassName("vbmOutputHead");
        inTXTText = document.getElementById('vbmInputText');
        outTXTText = document.getElementsByClassName("vbmOutputText");
        
        // TXT Layou 1
        vbmChangeText(inTXTSub, outTXTSub);
        vbmChangeText(inTXTHead, outTXTHead);
        vbmChangeText(inTXTText, outTXTText);

        // create and Downlaod canvas
        dcbtn = document.getElementById('genImgTxtLAOne');
        $( dcbtn).on( "click", function(e) {
          e.preventDefault;
          vbmCreateCanvasIMG(laGenBox);
        });
      } else if ($('#imgPostLayout-1').length) {

        // canvas Box
        laGenBox = document.getElementById('imgLAOneGenBox');

        // img vars
        inImgLa  = document.getElementById('vbmInImg');
        outImgLa  = document.getElementById('vbmOPIImgLAOne');
        // change img
        changeImg(inImgLa, outImgLa);

        // create and Downlaod canvas
        dcbtn = document.getElementById('genImgImgLAOne');
        $(dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });

      } else if ($('#imgPostLayout-2').length) {

        // canvas Box
        laGenBox = document.getElementById('imgLATwoGenBox');

        // txt vars 
        inFiTxt = document.getElementById('inFiTxtImgLaTwo');
        outFiTxt = document.getElementsByClassName("outFiTxtImgLaTwo");
        inScTxt = document.getElementById('inScTxtImgLaTwo');
        outScTxt = document.getElementsByClassName("outScTxtImgLaTwo");

        setFontSize(laGenBox, '.head', '90');
        
        // change txt
        vbmChangeText(inFiTxt, outFiTxt);
        vbmChangeText(inScTxt, outScTxt);

        // img vars
        inImgLa  = document.getElementById('vbmInImgLaTwo');
        outImgLa  = document.getElementById('vbmOPIImgLATwo');

        // change img
        changeImg(inImgLa, outImgLa);

        // create and Downlaod canvas
        dcbtn = document.getElementById('genImgImgLATwo');
        $(dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });

      } else if ($('#imgPostLayout-3').length) {
        laGenBox  = document.getElementById('imgLAThreeGenBox');
        inImgLa   = document.getElementById('vbmInImgLaThree');
        outImgLa  = document.getElementById('vbmOPIImgLAThree');
        changeImg(inImgLa, outImgLa);
        dcbtn = document.getElementById('genImgImgLAThree');
        $(dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });
      } else if ($('#imgPostLayout-4').length) {

        // canvas Box
        laGenBox = document.getElementById('imgLAFourGenBox');

        // Border and txt sizes
        setFontSize(laGenBox, '.head', '90');
        setFontSize(laGenBox, '.subhead', '50');

        // TXT Change Vars TXT Layout one
        inTXTSub = document.getElementById('vbmInputSub');
        outTXTSub = document.getElementsByClassName("vbmOutputSub");
        inTXTHead = document.getElementById('vbmInputHead');
        outTXTHead = document.getElementsByClassName("vbmOutputHead");
        
        // TXT Layou 1
        vbmChangeText(inTXTSub, outTXTSub);
        vbmChangeText(inTXTHead, outTXTHead);
        vbmChangeText(inTXTText, outTXTText);


        // img vars
        inImgLa  = document.getElementById('vbmInImg');
        outImgLa  = document.getElementById('vbmOPIImgLAOne');
        // change img
        changeImg(inImgLa, outImgLa);

        // create and Downlaod canvas
        dcbtn = document.getElementById('genImgImgLAOne');
        $(dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });

      } else if ($('#eventPostLayout-1').length) {

        // Datepicker function
        $( '.datepicker' ).datepicker({
          showAnim: 'slideDown',
          changeMonth: true,
          changeYear: true,
          dateFormat: 'd MM yy',
          altField: '#eventDateOutput',
          altFormat: 'd MM yy',
        });

        var hiddenDate = $('[name="eventDateOutput"]').attr('value');
        $("#eventDateOut").html(hiddenDate);

        $('input[name=vbmInputDateEventOne]').change(function(){
          hiddenDate = $('[name="eventDateOutput"]').attr('value');
          $("#eventDateOut").html(hiddenDate);
        });

        // Timepicker function
        $('.timepicker').timepicker({
            timeFormat: 'HH:mm',
            interval: 15,
            dynamic: false,
            dropdown: true,
            scrollbar: false,
            zindex: 15,
            change: function(time) {
              // the input field
              var element = $(this);
              var options = { hour12: false, hour: '2-digit', minute:'2-digit' };
              var text = time.toLocaleTimeString('de-DE', options);

              element.val( text + ' Uhr');
              $('.vbmOutputTimeEvent > span').text(text);
          }
        
        });

        // canvas Box
        laGenBox = document.getElementById('eventLAOneGenBox');
        
        // Border and txt sizes
        setBorderMaskWidth(laGenBox, '.borderMask', '15');
        setFontSize(laGenBox, '.head', '90');
        setFontSize(laGenBox, '.subhead', '50');
        setFontSize(laGenBox, '.text', '40');
        setFontSize(laGenBox, '.eventTimeDate', '40');
        setFontSize(laGenBox, '.text', '40');
        setFontSize(laGenBox, '.hashtag', '45');
        setFontSize(laGenBox, '.eventLocation', '40');

        // TXT Change Vars TXT Layout one
        inTXTSub = document.getElementById('vbmInputSubEventOne');
        outTXTSub = document.getElementsByClassName("vbmOutputSubEventOne");
        inTXTHead = document.getElementById('vbmInputHeadEventOne');
        outTXTHead = document.getElementsByClassName("vbmOutputHeadEventOne");
        inTXTText = document.getElementById('vbmInputTextEventOne');
        outTXTText = document.getElementsByClassName("vbmOutputTextEventOne");
        inTXThash   = document.getElementById('vbmInputHashEventOne');
        outTXThash  = document.getElementsByClassName("vbmOutputHashEventOne");
        inTXTLoc    = document.getElementById('vbmInputLocEventOne');
        outTXTLoc   = document.getElementsByClassName("vbmOutputLocEventOne");;

        // TXT Layou 1
        vbmChangeText(inTXTSub, outTXTSub);
        vbmChangeText(inTXTHead, outTXTHead);
        vbmChangeText(inTXTText, outTXTText);
        vbmChangeText(inTXThash, outTXThash);
        vbmChangeText(inTXTLoc, outTXTLoc);

        // create and Downlaod canvas
        dcbtn = document.getElementById('genEventImgLAOne');
        $( dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });
      } else if ($('#eventPostLayout-2').length) {

        // Datepicker function
        $( '.datepicker' ).datepicker({
          showAnim: 'slideDown',
          changeMonth: true,
          changeYear: true,
          dateFormat: 'd MM yy',
          altField: '#eventDateOutput',
          altFormat: 'd MM yy',
        });

        var hiddenDate = $('[name="eventDateOutput"]').attr('value');
        $("#eventDateOut").html(hiddenDate);

        $('input[name=vbmInputDateEventTwo]').change(function(){
          hiddenDate = $('[name="eventDateOutput"]').attr('value');
          $("#eventDateOut").html(hiddenDate);
        });

        // Timepicker function
        $('.timepicker').timepicker({
            timeFormat: 'HH:mm',
            interval: 15,
            dynamic: false,
            dropdown: true,
            scrollbar: false,
            zindex: 15,
            change: function(time) {
              // the input field
              var element = $(this);
              var options = { hour12: false, hour: '2-digit', minute:'2-digit' };
              var text = time.toLocaleTimeString('de-DE', options);

              element.val( text + ' Uhr');
              $('.vbmOutputTimeEvent').text(text);
          }
        
        });

        // canvas Box
        laGenBox = document.getElementById('eventLATwoGenBox');
        
        // Border and txt sizes
        setBorderMaskWidth(laGenBox, '.borderMask', '15');
        setFontSize(laGenBox, '.head', '90');
        setFontSize(laGenBox, '.subhead', '50');
        setFontSize(laGenBox, '.text', '40');
        setFontSize(laGenBox, '.eventTimeDate', '40');
        setFontSize(laGenBox, '.text', '40');
        setFontSize(laGenBox, '.hashtag', '45');
        setFontSize(laGenBox, '.eventLocation', '40');

        // TXT Change Vars TXT Layout one
        inTXTSub = document.getElementById('vbmInputSubEventTwo');
        outTXTSub = document.getElementsByClassName("vbmOutputSubEventTwo");
        inTXTHead = document.getElementById('vbmInputHeadEventTwo');
        outTXTHead = document.getElementsByClassName("vbmOutputHeadEventTwo");
       
        inTXTLoc    = document.getElementById('vbmInputLocEventTwo');
        outTXTLoc   = document.getElementsByClassName("vbmOutputLocEventTwo");;

        // TXT Layou 1
        vbmChangeText(inTXTSub, outTXTSub);
        vbmChangeText(inTXTHead, outTXTHead);
        vbmChangeText(inTXTLoc, outTXTLoc);

        // img vars
        inImgLa  = document.getElementById('eventOpiImgInput');
        outImgLa  = document.getElementById('eventOpiImg');

        // change img
        changeImg(inImgLa, outImgLa);


        // create and Downlaod canvas
        dcbtn = document.getElementById('genEventImgLATwo');
        $( dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });
      }
      



      if ( $('.cuImg').length ) {
        $(document).keydown(function(e){
          switch (e.which){
          case 37:    //left arrow key
            $(".cuImg").finish().animate({
                left: "-=5"
            });
            break;
          case 39:    //right arrow key
            $(".cuImg").finish().animate({
                left: "+=5"
            });
            break;
          }
        });
      }

    }
  });

  // Initialize the leaveStep event
  /////////////////////////////////////////
  $(smartwizard).on("leaveStep", function(e, anchorObject, currentStepIndex, nextStepIndex, stepDirection) {
    if (currentStepIndex == 1 ) {
      $('#select-design').data('content', postTypeUrl);
    } else  if (currentStepIndex == 2 ) {
      $('#selected-design').data('content', postTypeUrl);
    }
  });


  // Set Start BTN Next Step
  /////////////////////////////////////////
  $(nextBtn).on( "click", function(e) {
    //$(smartwizard).smartWizard('next', 1, true);
    $(smartwizard).smartWizard("next");
    e.target.blur();
  });

  // Set Start BTN Next Step 
  //$(designBtn).on( "click", function() {
  //  $(smartwizard).smartWizard('goToStep', 2, true);
  //  //$(smartwizard).smartWizard("next");
  //});


  // Tabs Function for Layout select
  ///////////////////////////////////////////////////////////

  // TXT Layouts Tabs
  /*
  $( "#vbmTxtSelect" ).tabs({
    collapsible: true,
    active: false,
    show: { effect: "fade", duration: 500 },
    hide: { effect: "fade", duration: 500 },
    activate: function( event, ui ) {

      var tabIndex = ui.newTab.index();

      $('#vbmTxtSelect').tabs( "refresh" );

      if (tabIndex == 0) {
        // canvas Box
        laGenBox = document.getElementById('txtLAOneGenBox');
        
        // Border and txt sizes
        setBorderMaskWidth(laGenBox, '.borderMask', '15');
        setFontSize(laGenBox, '.head', '90');
        setFontSize(laGenBox, '.subhead', '50');
        setFontSize(laGenBox, '.text', '40');

        // TXT Change Vars TXT Layout one
        inTXTSub = document.getElementById('vbmInputSub');
        outTXTSub = document.getElementsByClassName("vbmOutputSub");

        inTXTHead = document.getElementById('vbmInputHead');
        outTXTHead = document.getElementsByClassName("vbmOutputHead");

        inTXTText = document.getElementById('vbmInputText');
        outTXTText = document.getElementsByClassName("vbmOutputText");
        
        // TXT Layou 1
        vbmChangeText(inTXTSub, outTXTSub);
        vbmChangeText(inTXTHead, outTXTHead);
        vbmChangeText(inTXTText, outTXTText);

        // create and Downlaod canvas
        dcbtn = document.getElementById('genImgTxtLAOne');
        $( dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });

      }
    }
  });

   // IMG Layouts Tabs

  $( "#vbmImgSelect" ).tabs({
    collapsible: true,
    active: false,
    show: { effect: "fade", duration: 500 },
    hide: { effect: "fade", duration: 500 },
    heightStyle: 'auto',
    activate: function( event, ui ) {
      
      tabIndex = ui.newTab.index();

      $('#vbmImgSelect').tabs( "refresh" );

      // vars TXT | IMG Layout Two
      //////////////////////////////////////////

      if (tabIndex == 0) {

        // canvas Box
        laGenBox = document.getElementById('imgLAOneGenBox');

        // img vars
        inImgLa  = document.getElementById('vbmInImg');
        outImgLa  = document.getElementById('vbmOPIImgLAOne');
        // change img
        changeImg(inImgLa, outImgLa);

        // create and Downlaod canvas
        dcbtn = document.getElementById('genImgImgLAOne');
        $(dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });

      } else if (tabIndex == 1) {

        // canvas Box
        laGenBox = document.getElementById('imgLATwoGenBox');

        // txt vars 
        inFiTxt = document.getElementById('inFiTxtImgLaTwo');
        outFiTxt = document.getElementsByClassName("outFiTxtImgLaTwo");

        inScTxt = document.getElementById('inScTxtImgLaTwo');
        outScTxt = document.getElementsByClassName("outScTxtImgLaTwo");

        setFontSize(laGenBox, '.head', '90');
        
        // change txt
        vbmChangeText(inFiTxt, outFiTxt);
        vbmChangeText(inScTxt, outScTxt);

        // img vars
        inImgLa  = document.getElementById('vbmInImgLaTwo');
        outImgLa  = document.getElementById('vbmOPIImgLATwo');

        // change img
        changeImg(inImgLa, outImgLa);

        // create and Downlaod canvas
        dcbtn = document.getElementById('genImgImgLATwo');
        $(dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });

      } else if (tabIndex == 2) {

        // canvas Box
        laGenBox = document.getElementById('imgLAThreeGenBox');

        // img vars
        inImgLa  = document.getElementById('vbmInImgLaThree');
        outImgLa  = document.getElementById('vbmOPIImgLAThree');

        // change img
        changeImg(inImgLa, outImgLa);


        // create and Downlaod canvas
        dcbtn = document.getElementById('genImgImgLAThree');
        $(dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });
      }

    }
  });

  // Event Layouts Tabs
  $( "#vbmEventSelect" ).tabs({
    collapsible: true,
    active: false,
    show: { effect: "fade", duration: 500 },
    hide: { effect: "fade", duration: 500 },
    activate: function( event, ui ) {

      var tabIndex = ui.newTab.index();

      $('#vbmEventSelect').tabs( "refresh" );

      // Datepicker function
      $( '.datepicker' ).datepicker({
        showAnim: 'slideDown',
        changeMonth: true,
        changeYear: true,
        dateFormat: 'd MM yy',
        altField: '#eventDateOutput',
        altFormat: 'd MM yy',
      });

      // Timepicker function
      $('.timepicker').timepicker({
          timeFormat: 'HH:mm',
          interval: 15,
          dynamic: false,
          dropdown: true,
          scrollbar: false,
          zindex: 15,
          change: function(time) {
            // the input field
            var element = $(this);
            var options = { hour12: false, hour: '2-digit', minute:'2-digit' };
            var text = time.toLocaleTimeString('de-DE', options);

            element.val( text + ' Uhr');
            $('.vbmOutputTimeEventOne').text(text);
        }
      
      });

      if (tabIndex == 0) {
        // canvas Box
        laGenBox = document.getElementById('eventLAOneGenBox');
        
        // Border and txt sizes
        setBorderMaskWidth(laGenBox, '.borderMask', '15');
        setFontSize(laGenBox, '.head', '90');
        setFontSize(laGenBox, '.subhead', '50');
        setFontSize(laGenBox, '.text', '40');
        setFontSize(laGenBox, '.eventTimeDate', '40');
        setFontSize(laGenBox, '.text', '40');
        setFontSize(laGenBox, '.hashtag', '45');
        setFontSize(laGenBox, '.eventLocation', '40');

        // TXT Change Vars TXT Layout one
        inTXTSub = document.getElementById('vbmInputSubEventOne');
        outTXTSub = document.getElementsByClassName("vbmOutputSubEventOne");

        inTXTHead = document.getElementById('vbmInputHeadEventOne');
        outTXTHead = document.getElementsByClassName("vbmOutputHeadEventOne");

        inTXTText = document.getElementById('vbmInputTextEventOne');
        outTXTText = document.getElementsByClassName("vbmOutputTextEventOne");

        inTXThash   = document.getElementById('vbmInputHashEventOne');
        outTXThash  = document.getElementsByClassName("vbmOutputHashEventOne");

        inTXTLoc    = document.getElementById('vbmInputLocEventOne');
        outTXTLoc   = document.getElementsByClassName("vbmOutputLocEventOne");;

        
        // TXT Layou 1
        vbmChangeText(inTXTSub, outTXTSub);
        vbmChangeText(inTXTHead, outTXTHead);
        vbmChangeText(inTXTText, outTXTText);
        vbmChangeText(inTXThash, outTXThash);
        vbmChangeText(inTXTLoc, outTXTLoc);

    
        // create and Downlaod canvas
        dcbtn = document.getElementById('genEventImgLAOne');
        $( dcbtn).on( "click", function() {
          vbmCreateCanvasIMG(laGenBox);
        });

      }
    }
  });

  */

  // Set Randow Scale hover for Layouboxes
  ///////////////////////////////////////////////////////////
  var BoxHover = $('.vbmLayBoxIcon');

  $(BoxHover).hover(function() {
    var a = Math.random() * 10 - 5;
    $(this).css('transform', 'rotate(' + a + 'deg) scale(1.1)');
  }, function() {
    $(this).css('transform', 'none');
  });


  // Fn to allow an event to fire after all images are loaded
  ///////////////////////////////////////////////////////////
  $.fn.imagesLoaded = function () {
    // get all the images (excluding those with no src attribute)
    var $imgs = this.find('img[src!=""]');
    // if there's no images, just return an already resolved promise
    if (!$imgs.length) {return $.Deferred().resolve().promise();}
    // for each image, add a deferred object to the array which resolves when the image is loaded (or if loading fails)
    var dfds = [];  
    $imgs.each(function(){
        var dfd = $.Deferred();
        dfds.push(dfd);
        var img = new Image();
        img.onload = function(){dfd.resolve();}
        img.onerror = function(){dfd.resolve();}
        img.src = this.src;
    });
    // return a master promise object which will resolve when all the deferred objects have resolved
    // IE - when all the images are loaded
    return $.when.apply($,dfds);
  }

});


// show hide sections for Layout etc
///////////////////////////////////////////////////////////
/*
const poTySelSec = $('#vbmPostTypeSelect');

$( "#vbmLayBoxText" ).on( "click", function() {
  $(poTySelSec).hide( 'fade', 500, showSelectSection("#vbmTxtSelect") );
});

$( "#vbmLayBoxImg" ).on( "click", function() {
  $(poTySelSec).hide( 'fade', 500, showSelectSection("#vbmImgSelect") );
});

$( "#vbmLayBoxtEvent" ).on( "click", function() {
  $(poTySelSec).hide( 'fade', 500, showSelectSection("#vbmEventSelect") );
});


function showSelectSection(el) {
  setTimeout(function() {
    $( el ).show( 'fade', 500 );
  }, 520 );
};
*/

// Set functions for calculate border | textsizes on scale
///////////////////////////////////////////////////////////

function setBorderMaskWidth(wrap, borderCont, borderWi) {
  jQuery(window).on('resize', function(){
    var wrapBox     = wrap;
    var wrapBoxWi   = wrapBox.offsetWidth;
    var scaleIndex  = ((100 / 1080) * borderWi) / 100;
    var borderWidth = wrapBoxWi * scaleIndex;
    jQuery(borderCont).css('border-width', borderWidth);
  });
  jQuery(window).trigger('resize');
}

function setFontSize(wrap, fontEl, num) {
  jQuery(window).on('resize', function(){
    var wrapBox     = wrap;
    var wrapBoxWi   = wrapBox.offsetWidth;
    var scaleIndex  = ((100 / 1080) * num) / 100;
    var fontsize    = wrapBoxWi * scaleIndex;
    jQuery(fontEl).css('font-size', fontsize);
  });
  jQuery(window).trigger('resize');
}


// Set Vars for Canvas picture
/////////////////////////////////////////////////////////

// Canbox Vars
var svgEl   = document.body.querySelectorAll('svg');

var _URL = window.URL || window.webkitURL;
var coImg = 'img/ek-socialGen-BGcolor.jpg';

// Update TXT Function
/////////////////////////////////////////////////////////

function vbmChangeText(input, output) {
  input.onkeyup = function() {
    for(var i = 0; i < output.length; i++){
      output.item(i).innerHTML = input.value;
    }
  }
}

function vbmChangeDate(input, output) {
  input.onkeyup = function() {
    for(var i = 0; i < output.length; i++){
      output.item(i).innerHTML = input.value;
    }
  }
}

// Update user img width input
/////////////////////////////////////////////////////////
function changeImg(input, imgBox) {
  $(input).change(function(e) {
    var image, file;
    if ((file = this.files[0])) {
      image = new Image();
      image.onload = function() {
        src = this.src;
        $(imgBox).html('<img src="'+ src +'" class="cuImg"  alt="HSTL – IMG Post Layout">');
        //$('#vbmOPI').css('background-image', 'url(' + src + ')');
        e.preventDefault();
      }
    }; 
    image.src = _URL.createObjectURL(file);
  });
}

// Set Element width and Height for rendering
/////////////////////////////////////////////////////////
function vbmSetWiHi(el) {
  el.forEach(function(item) {
    item.setAttribute("width", item.getBoundingClientRect().width);
    item.setAttribute("height", item.getBoundingClientRect().height);
    item.style.width = null;
    item.style.height= null;
  });
}

// Remove Element width and Height for rendering
/////////////////////////////////////////////////////////
function vbmRemWiHi(el) {
  el.forEach(function(item) {
    item.removeAttribute("width");
    item.removeAttribute("height");
  });
}

// create canvas container
/////////////////////////////////////////////////////////
function vbmCreateCanvasIMG(canBoxId) {

  var canBox         = canBoxId;
  var canBoxWi       = canBox.offsetWidth;
  var canBoxHi       = canBox.offsetHeight;
  var canBoxOffY     = canBox.offsetTop;
  var canBoxOffX     = canBox.offsetLeft;
  var scaleFac       = 1080 / canBoxWi;
  var pageOffset     = window.pageYOffset;
  var yps            = pageOffset * 2;

  vbmSetWiHi(svgEl);

  html2canvas(canBox, {
    scale: scaleFac,
    width: canBoxWi,
    height: canBoxHi,
    useCORS: true,
    onclone: function() {
      console.log('loading Canvas');
    }
  }).then( canvas => {
    // save Canvas by set to Blob

    // document.body.appendChild(canvas)
    canvas.setAttribute("id", "vbmCR");
    
    canvas.toBlob(function(blob) {
      saveAs(blob, "hstlSocialGen.png");
    }, "image/png");
    
    vbmRemWiHi(svgEl);
  
  });
}




